import styles from 'styles/modules/Sidescreen.module.scss';
import { useEffect, useState } from 'react';
import EditCompanyInfo from './Sidescreen/EditCompanyInfo';
import AddExpert from './Sidescreen/AddExpert';
import AddMediaCoverage from './Sidescreen/AddMediaCoverage';
import EditMediaCoverage from './Sidescreen/EditMediaCoverage';
import AddFiles from './Sidescreen/AddFiles';
import EditAddresses from './EditAddresses';
import { useDispatch, useSelector } from 'react-redux';
import { handleHideSidescreen, uxSelector } from 'store/ux';
import { companySelector } from 'store/company';
import { profile } from 'lang/en';

const Sidescreen = ({ onUpdate }) => {
    const dispatch = useDispatch();
    const { sidescreen } = useSelector(uxSelector);
    const { data } = useSelector(companySelector);
    const [activeUploadPopup, setActiveUploadPopup] = useState(false);
    let contentComponent;
    useEffect(() => {}, [sidescreen]);
    const showUploadPopup = () => {
        setActiveUploadPopup(true);
    };

    const hideUploadPopup = () => {
        setActiveUploadPopup(false);
    };

    const { files } = data;

    switch (sidescreen.content) {
        case 'edit-description':
        case 'edit-info':
            contentComponent = (
                <EditCompanyInfo
                    onUpdate={onUpdate}
                    isJournalist={data.isJournalist}
                    title={profile.header.details.sidebar.title}
                />
            );
            break;
        case 'add-mediaCoverage':
            contentComponent = (
                <AddMediaCoverage
                    onUpdate={onUpdate}
                    title={profile.media_coverage.sidebar.title}
                />
            );
            break;
        case 'edit-mediaCoverage':
            contentComponent = <EditMediaCoverage />;
            break;
        case 'add-file':
            if (!files) return null;
            contentComponent = (
                <AddFiles
                    files={files}
                    title={profile.mediaPack.title}
                    showUploadPopup={showUploadPopup}
                    hideUploadPopup={hideUploadPopup}
                    activeUploadPopup={activeUploadPopup}
                />
            );
            break;
        case 'add-address':
        case 'edit-addresses':
            contentComponent = (
                <EditAddresses
                    onUpdate={onUpdate}
                    title={
                        data.addresses.length > 0
                            ? profile.header.address.sidebar.title
                            : profile.header.address.sidebar.title_no_address
                    }
                />
            );
            break;
        default:
            contentComponent = null;
            break;
    }

    useEffect(() => {
        const handleKeyUp = (e) => {
            const key = e.key?.toLowerCase();
            if (key === 'escape') {
                dispatch(handleHideSidescreen());
            }
        };

        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    return (
        <aside
            className={[
                styles.sidescreen,
                sidescreen.active ? styles.sidescreenActive : null,
                activeUploadPopup ? styles.popupActive : null,
            ].join(' ')}
        >
            <div className={styles.body}>{contentComponent}</div>
        </aside>
    );
};

export default Sidescreen;
